import React, { FunctionComponent } from 'react';
import { IPrismicContentElement } from '@/pageGeneration/services/prismicApi/types';

interface IProps {
  content: IPrismicContentElement[];
  Component: FunctionComponent<IPrismicContentElement>;
}

/**
 * PrismicContentSectionRenderer
 *
 * @param content: an array of IPrismicContentElement
 * @param Component: a component that can render using text, title, and image from a IPrismicContentElement
 * @constructor
 *
 * When pulling content from Prismic, you may see a pattern of contentTop, contentMiddle, contentBottom
 * If any of these is a generic Content data block (meaning that the payload of contentTop is an array of IPrismicContentElements,
 * we should use this renderer to generically apply a Component to an array of ContentElements
 */
const PrismicContentSectionRenderer: FunctionComponent<IProps> = ({ content, Component }) => (
  <>
    {content.map(({ title, text, image }, index) => (
      <Component key={`keyPrefix-${index}`} title={title} image={image} text={text} />
    ))}
  </>
);

export default PrismicContentSectionRenderer;
